import ReactGA from "react-ga4";

const googleAnalyticsToken = process.env.GOOGLE_ANALYTICS_ID;

// Check if the URL contains 'qa'
const isQAEnv = typeof window !== "undefined" && window.location.href.toLowerCase().includes("qa");

if (googleAnalyticsToken && !isQAEnv) {
    ReactGA.initialize(googleAnalyticsToken);
    console.log("%cGoogle Analytics initialized", "background-color:green;color:white;border-radius:8px;padding: 2px 10px");
} else {
    console.log("%cGoogle Analytics, not available", "background-color:red;color:black;border-radius:8px;padding: 2px 10px");
}